import React from "react";
import useStore from "../../store";
import { PTMDialog } from "../../Components";

export default function Imprint() {
    const currentDialog = useStore((store) => store.dashboard.dialogs.currentOpenDialog);
    const setDialog = useStore((store) => store.dashboard.dialogs.setCurrentOpenDialog);

    return (
        <PTMDialog
            title="Impressum"
            open={currentDialog === "imprint"}
            onClose={() => setDialog("")}
            everywhereVisible
            fixedWidth={600}
        >
            <h5>Postanschrift</h5>
            <p>
                PORTHUN & THIEDE SYSTEMHAUS GmbH & Co.KG,
                <br />
                {" "}
                Wismarsche Straße 323 a,
                <br />
                {" "}
                19055
                Schwerin
                <br />
                <br />
                {" "}
                PORTHUN & THIEDE SOFTWAREENTWICKLUNGS- UND SCHULUNGS GmbH,
                <br />
                {" "}
                Wismarsche Straße 323
                a,
                <br />
                {" "}
                19055 Schwerin
                <br />
            </p>
            <h5>
                Verantwortlich
                <br />
                <small>Gemäß §6 TDG</small>
            </h5>
            <p>
                Porthun & Thiede Systemhaus GmbH & Co.KG
                <br />
                {" "}
                Tel.: 0385/ 59 58 690
                <br />
                {" "}
                Fax. 0385/ 59 58
                699
                <br />
                {" "}
                Email: info(at)pt-systemhaus.de
                <br />
                {" "}
                Geschäftsführer:Herr Hajo Porthun, Herr Jörg
                Thiede
                <br />
                {" "}
                USt.ID-Nr.: DE262723580
                <br />
                {" "}
                Amtsgericht: Schwerin HRA 2931
                <br />
                {" "}
                Pers. haft.
                Gesellschafterin: Porthun & Thiede Verwaltungs GmbH
                <br />
                {" "}
                Amtsgericht: Schwerin HRB 9989
            </p>

            <h5>Programmierung und Design</h5>

            <p>
                PORTHUN & THIEDE SOFTWAREENTWICKLUNGS- UND SCHULUNGS GmbH
                <br />
                <a href="http://www.pt-systemhaus.de/software.html">www.pt-systemhaus.de</a>
            </p>

            <p>
                Das Layout der Homepage, die verwendeten Grafiken und Fotos sowie Texte sind urheberrechtlich geschützt.
                Alle Informationen auf diesem Server erfolgen ohne Gewähr für ihre Richtigkeit. In keinem Fall wird für
                Schäden, die sich aus der Verwendung der abgerufenen Informationen ergeben, eine Haftung übernommen.
                Links zu externen Informationsanbietern sind durch das Öffnen eines neuen Browser-Fensters
                gekennzeichnet. Die Verantwortung für die dortigen Inhalte liegt bei den jeweiligen
                Informationsanbietern.
                <br />
                {" "}
                Wir distanzieren uns hiermit ausdrücklich pro forma von Inhalten auf Seiten,
                auf die per Link verwiesen wird.
            </p>

            <h5>Haftungsbeschränkung</h5>

            <p>
                Die Inhalte dieser Website wurden mit größter Sorgfalt erstellt. Für die Richtigkeit, Vollständigkeit
                und Aktualität der Inhalte kann der Anbieter jedoch keine Gewähr Übernehmen. Haftungsansprüche gegen den
                Anbieter, welche sich auf Schäden materieller oder ideeller Art beziehen, die durch die Nutzung oder
                Nichtnutzung der dargebotenen Informationen bzw. durch die Nutzung fehlerhafter und unvollständiger
                Informationen verursacht wurden, sind grundsätzlich ausgeschlossen, sofern seitens des Anbieters kein
                nachweislich vorsätzliches oder grob fahrlässiges Verschulden vorliegt. Alle Angebote sind freibleibend
                und unverbindlich.
            </p>
        </PTMDialog>

    );
}
